import { FieldConfig } from 'formik';
import { HTMLInputTypeAttribute, MouseEventHandler } from 'react';
import { InterfaceLanguage, SnackbarType } from 'types/enums';
import { UrlObject } from 'url';

export type Nullable<T> = T | null;

export class RequestError extends Error {
  message: string;
  code: number;
  isNotFoundError: boolean;

  constructor(message: string, code: number) {
    super(message);
    this.message = message;
    this.code = code;
    this.isNotFoundError = code === 404;
  }
}
export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};

export interface IPagination<T> {
  data: T[];
  total: number;
  page: number;
  pageCount: number;
  count: number;
}

export interface IPaginationResponse<T> extends Omit<IPagination<T>, 'pageCount' | 'count'> {
  pages: number;
}

export interface IPaginationRequest {
  page: number;
  limit: number;
}
export type FieldIconName =
  | 'field_phone'
  | 'field_name'
  | 'field_comment'
  | 'field_date'
  | 'field_time'
  | 'field_persons'
  | 'field_email';

export type InputStyleType =
  | 'default'
  | 'bottomBorder'
  | 'blueBottomBorder'
  | 'defaultSmall'
  | 'defaultExSmall'
  | 'profile'
  | 'cashForm'
  | 'promo'
  | 'subscribe'
  | 'feedback'
  | 'hidden';
export interface IField<T> extends FieldConfig<T> {
  label?: string;
  placeholder?: string;
  iconName?: FieldIconName;
  type?: HTMLInputTypeAttribute;
  error?: string;
  description?: string;
  disabled?: boolean;
}
export interface IOption<T> {
  label: string | React.JSX.Element | React.JSX.Element[];
  value?: T;
  disabled?: boolean;
  description?: string;
  className?: string;
  id?: any;
}

export interface SnackbarData {
  text: string;
  type: SnackbarType;
}
export interface IButton {
  type?: 'submit' | 'reset' | 'button' | undefined;
  form?: string;
  spinner?: boolean;
  disabled?: boolean;
  onClick?: MouseEventHandler;
  href?: string | UrlObject;
  isExternalHref?: boolean; // add target blank and no referrer
}

export interface NavigationSet<T extends string | number> {
  name: string;
  type: T;
  icon?: React.JSX.Element;
  subSet?: React.JSX.Element | React.JSX.Element[];
}

export type FieldWithModifications<Values> = {
  field: keyof Values;
  required?: boolean;
  checkbox?: boolean;
};

export type UnknownFunction = (...args: any) => any;

export type InterfaceLanguageUnion = (typeof InterfaceLanguage)[keyof typeof InterfaceLanguage];
